export default "__VITE_ASSET__b6761050__"